type DialogLike = {
  hasAttribute(name: string): boolean
  getClientRects(): { length: number }
}

type DialogQueryRoot = {
  querySelectorAll(selector: string): ArrayLike<DialogLike>
}

/**
 * Timed promotional UI must yield to an existing modal. `inert` keeps closed
 * navigation drawers in the DOM, while `getClientRects()` excludes hidden
 * dialogs that are not currently presented to the user.
 */
export function hasActiveModalDialog(root: DialogQueryRoot): boolean {
  const dialogs = root.querySelectorAll('[role="dialog"]')

  return Array.from(dialogs).some(
    (dialog) => !dialog.hasAttribute('inert') && dialog.getClientRects().length > 0,
  )
}
